import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { Biblioteca, FiltersBase } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<Biblioteca>()

export function TableBiblioteche({
  biblioteche,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  biblioteche: Biblioteca[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {

  const numPages = useMemo(() => {
    if (!biblioteche) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [biblioteche, count])
  
  return (
    <Table
      data={biblioteche}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(biblioteca) => (
          <Link to={`/biblioteche/biblioteche/${biblioteca.id}`}>
            <LinkMagik className="text-dark">{biblioteca.nome}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />
      <Table.Column
        title="Città"
        name="citta"
        sortable
        width="minmax(max-content, 1fr)"
        render={(biblioteca) => (
          biblioteca.citta
        )}
      />
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} biblioteche
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>

    </Table>
  )
}
